import { RouteObject } from "react-router-dom";
import { lazy } from "react";

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const CasesPage = lazy(() => import('../pages/cases/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const QuotePage = lazy(() => import('../pages/quote/page'));
const ServiceAreaPage = lazy(() => import('../pages/service-area/page'));
const KnowledgePage = lazy(() => import('../pages/knowledge/page'));
const ArticlePage = lazy(() => import('../pages/knowledge/article/page'));
const TagsPage = lazy(() => import('../pages/knowledge/tags/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Area pages
const TaipeiAreaPage = lazy(() => import('../pages/area/taipei/page'));
const NewTaipeiAreaPage = lazy(() => import('../pages/area/new-taipei/page'));
const TaoyuanAreaPage = lazy(() => import('../pages/area/taoyuan/page'));
const HsinchuAreaPage = lazy(() => import('../pages/area/hsinchu/page'));
const TaichungAreaPage = lazy(() => import('../pages/area/taichung/page'));
const TainanAreaPage = lazy(() => import('../pages/area/tainan/page'));
const KaohsiungAreaPage = lazy(() => import('../pages/area/kaohsiung/page'));
const ChanghuaAreaPage = lazy(() => import('../pages/area/changhua/page'));
const KeelungAreaPage = lazy(() => import('../pages/area/keelung/page'));
const MiaoliAreaPage = lazy(() => import('../pages/area/miaoli/page'));
const YilanAreaPage = lazy(() => import('../pages/area/yilan/page'));
const NantouAreaPage = lazy(() => import('../pages/area/nantou/page'));
const ChiayiAreaPage = lazy(() => import('../pages/area/chiayi/page'));
const PingtungAreaPage = lazy(() => import('../pages/area/pingtung/page'));
const HualienAreaPage = lazy(() => import('../pages/area/hualien/page'));
const TaitungAreaPage = lazy(() => import('../pages/area/taitung/page'));

// New pages
const ChecklistPage = lazy(() => import('../pages/checklist/page'));
const CalculatorPage = lazy(() => import('../pages/calculator/page'));
const CasesDetailPage = lazy(() => import('../pages/cases-detail/page'));
const CaseDetail1Page = lazy(() => import('../pages/case-detail-1/page'));
const CaseDetail2Page = lazy(() => import('../pages/case-detail-2/page'));
const CaseDetail3Page = lazy(() => import('../pages/case-detail-3/page'));
const CaseDetail4Page = lazy(() => import('../pages/case-detail-4/page'));
const PriceComparisonPage = lazy(() => import('../pages/price-comparison/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/pricing',
    element: <PricingPage />,
  },
  {
    path: '/price-comparison',
    element: <PriceComparisonPage />,
  },
  {
    path: '/cases',
    element: <CasesPage />
  },
  {
    path: '/cases-detail',
    element: <CasesDetailPage />
  },
  {
    path: '/case-detail-1',
    element: <CaseDetail1Page />
  },
  {
    path: '/case-detail-2',
    element: <CaseDetail2Page />
  },
  {
    path: '/case-detail-3',
    element: <CaseDetail3Page />
  },
  {
    path: '/case-detail-4',
    element: <CaseDetail4Page />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/quote',
    element: <QuotePage />
  },
  {
    path: '/service-area',
    element: <ServiceAreaPage />
  },
  {
    path: '/knowledge',
    element: <KnowledgePage />
  },
  {
    path: '/knowledge/article/:slug',
    element: <ArticlePage />
  },
  {
    path: '/knowledge/tags',
    element: <TagsPage />
  },
  {
    path: '/faq',
    element: <FAQPage />
  },
  {
    path: '/checklist',
    element: <ChecklistPage />
  },
  {
    path: '/calculator',
    element: <CalculatorPage />
  },
  // Area pages
  {
    path: '/area/taipei',
    element: <TaipeiAreaPage />
  },
  {
    path: '/area/new-taipei',
    element: <NewTaipeiAreaPage />
  },
  {
    path: '/area/taoyuan',
    element: <TaoyuanAreaPage />
  },
  {
    path: '/area/hsinchu',
    element: <HsinchuAreaPage />
  },
  {
    path: '/area/taichung',
    element: <TaichungAreaPage />
  },
  {
    path: '/area/tainan',
    element: <TainanAreaPage />
  },
  {
    path: '/area/kaohsiung',
    element: <KaohsiungAreaPage />
  },
  {
    path: '/area/changhua',
    element: <ChanghuaAreaPage />
  },
  {
    path: '/area/keelung',
    element: <KeelungAreaPage />
  },
  {
    path: '/area/miaoli',
    element: <MiaoliAreaPage />
  },
  {
    path: '/area/yilan',
    element: <YilanAreaPage />
  },
  {
    path: '/area/nantou',
    element: <NantouAreaPage />
  },
  {
    path: '/area/chiayi',
    element: <ChiayiAreaPage />
  },
  {
    path: '/area/pingtung',
    element: <PingtungAreaPage />
  },
  {
    path: '/area/hualien',
    element: <HualienAreaPage />
  },
  {
    path: '/area/taitung',
    element: <TaitungAreaPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
